<template>
    <div>
        <a-result status="403" title="403" sub-title="抱歉，您没有访问权限">
            <template #extra>
            <a-button type="primary"  @click="go_home">
                返回首页
            </a-button>
            </template>
        </a-result>
    </div>
    
</template>

<script>
export default {
    methods:{
        go_home(){
            this.$router.push({
                path: "index"
            });
        }
    }
};
</script>

<style scoped>
</style>